module.exports = __webpack_public_path__ + "img/15-5.5a96fc70.png";